import { render, staticRenderFns } from "./NeighborManage.vue?vue&type=template&id=092d5db3&"
import script from "./NeighborManage.vue?vue&type=script&lang=js&"
export * from "./NeighborManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports